import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import { absoluteMiddleCenter } from '../../styles/mixins';
import { FA_SELECTOR } from '../../styles/variables';

export const useMonitorJobMapLegendStyles = createStyles(({ token }) => ({
  monitorMapLegend: {
    position: 'absolute',
    top: ThemeSpaces.SPACE_NORM,
    right: ThemeSpaces.SPACE_NORM,

    backgroundColor: ThemeColors.COLOR_WHITE2,
    border: `1px solid ${token.colorWhite}`,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,
    boxShadow: `-1px -1px 1px ${token.colorWhite}, 6px 6px 15px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY6, 0.35)}`,
    paddingTop: ThemeSpaces.SPACE_XXS,
    transition: `width ${token.motionDurationSlow} ease-in-out, height ${token.motionDurationSlow} ease-in-out`,
    overflow: 'hidden',

    '&.closed': {
      width: 75,
      height: 30,
      paddingLeft: ThemeSpaces.SPACE_SM,
    },
    '&.open': {
      width: 150,
      paddingBottom: ThemeSpaces.SPACE_XS,
      paddingLeft: ThemeSpaces.SPACE_NORM,
    },
  },
  title: {
    fontSize: token.fontSizeLG,
    lineHeight: '24px',
    textTransform: 'uppercase',
    fontFamily: ThemeFont.FONT_CONDENSED,
    color: ThemeColors.COLOR_GREY_BLUISH7_2,
  },
  text: {
    width: 140,
    fontSize: token.fontSize,
    fontWeight: 500,
    lineHeight: '24px',

    '> div': {
      display: 'flex',
      alignItems: 'center',
      height: 24,
    },

    '.label': {
      width: 93,
    },
    '.icon': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 40,

      [FA_SELECTOR]: {
        ...absoluteMiddleCenter(),
        color: token.colorWhite,
        fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
      },

      '.text-label': {
        ...absoluteMiddleCenter(),
        color: token.colorWhite,
        fontSize: token.fontSize,
        fontWeight: 'bold',
      },
    },
  },
}));
